import React from 'react';
import { formatDateTime } from '../../utils/formatters';
import { LOG_LEVEL_COLORS } from '../../utils/constants';

/**
 * 로그 아이템 컴포넌트 (모바일용 리스트 형태)
 */
const LogItem = ({ log }) => {
  const levelColor = LOG_LEVEL_COLORS[log.level];

  // 레벨에 따른 border 색상
  const borderColor = {
    'INFO': 'border-l-gray-500',
    'WARNING': 'border-l-yellow-500',
    'ERROR': 'border-l-red-500',
  }[log.level] || 'border-l-gray-500';

  return (
    <div className={`bg-gray-800 rounded-lg p-3 mb-2 border-l-4 ${borderColor}`}>
      {/* 헤더: 시간과 레벨 */}
      <div className="flex justify-between items-center mb-2">
        <span className="text-xs text-gray-500">
          {formatDateTime(log.timestamp)}
        </span>
        <span className={`text-xs font-bold ${levelColor}`}>
          {log.level}
        </span>
      </div>

      {/* 카테고리 */}
      <div className="text-xs text-gray-400 mb-1">
        {log.category}
      </div>

      {/* 메시지 */}
      <div className="text-sm text-white">
        {log.message}
      </div>
    </div>
  );
};

export default LogItem;
